import { Box, CircularProgress, Grid, Paper, TextField } from "@mui/material"
import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { LinearProgress } from "@mui/material";
import * as yup from 'yup';

import { List, Card, CardHeader, ListItem, ListItemText, ListItemIcon, Checkbox, Button, IconButton, Divider, Icon, Typography, useTheme, FormControl, FormLabel, FormControlLabel, RadioGroup, Radio, ClickAwayListener } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import styled from '@emotion/styled';
import { useAppThemeContext } from '../../shared/contexts';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';

import { ISetor, SetorService } from "../../shared/services/api/setor/SetorService";
import { Detalhe_Caixa_Service, ISetor_Caixa, IIndice_caixa } from "../../shared/services/api/caixa/Detalhe_Caixa_Service";
import { AlertSnackBar, AutoCompleteDeUnidade } from "../../shared/components";
import { IndicesCadastro } from "../../shared/components/indices/IndicesCadastro";
import { ConversorDeValorIndice } from "../../shared/components/indices/ConversorDeValorIndice";
import { CampoTextoMascarado } from "../../shared/components/campo-texto-mascarado/CampoTextoMascarado";
import { LayoutBaseDePagina } from "../../shared/layouts";
import { TipoService, IListagemTipo, RenderTree } from "../../shared/services/api/tipo/TipoService";
import { CaixaService } from "../../shared/services/api/caixa/CaixaService";
import { Environment } from "../../shared/environment";
import { VTextField, VForm, useVForm } from "../../shared/forms";
import { AutoCompleteDeTipoDeCaixa } from "../../shared/components/autocompletes/AutoCompleteDeTipoDeCaixa";
import { ITipo_Indice_Documento, Tipo_Indice_Service } from "../../shared/services/api/tipo_indice/Tipo_Indice_Service";

interface IFormData {
    localizador?: string,
    codigoBarras?: string,
    identificador?: string | null | undefined,
    obsevacao?: string,
    idTipoCaixa: number,
    qtdeEtiquetas: number
}
interface IFormDataSetores {
    idSetor: number,
    idCaixa: number,
}
interface IFormDataTipos {
    idTipo: number,
    idCaixa: number,
}

interface SetoresLista {
    idSetor: number;
    nomeSetor: string;
    disabled: boolean;
}

const formValidationSchema: yup.SchemaOf<IFormData> = yup.object().shape({
    // localizador: yup.string().required("Localizador é obrigatório").min(13, "Digite todos os caracteres"),
    idTipoCaixa: yup.number().required("Escolha o tipo da caixa"),
    qtdeEtiquetas: yup.number().required(),
    localizador: yup.string().notRequired(),
    codigoBarras: yup.string().notRequired(),
    identificador: yup.string().notRequired().nullable(),
    obsevacao: yup.string().notRequired(),
});



export const DetalheDeCaixa: React.FC = () => {

    const [expanded, setExpanded] = useState<string[]>([]);

    const { themeName } = useAppThemeContext();
    const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(() => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.background.paper,
            color: themeName === "light" ? 'rgba(0, 0, 0, 0.87)' : 'rgba(255, 255, 255, 0.8)',
            maxWidth: 220,
            border: '1px solid #dadde9',
        },
    }));

    const { idCaixa = 'nova' } = useParams<'idCaixa'>();
    const navigate = useNavigate();
    const theme = useTheme();

    const [idUnidade, setIdUnidade] = useState<number | undefined | null>(undefined);
    useEffect(() => { setIdUnidade(Number(localStorage.getItem("idUnidade"))) }, [])

    const [titulo, setTitulo] = useState<string>('');

    const [localizador, setLocalizador] = useState('');
    const [codigoBarras, setCodigoBarras] = useState('');
    const [tipoMascara, setTipoMascara] = useState("aa9-999-a-999");

    const [showTooltipMascara, setShowTooltipMascara] = useState(false);

    const handleTooltipMascaraClose = () => {
        setShowTooltipMascara(false);
    };

    const handleTooltipMascaraOpen = () => {
        setShowTooltipMascara(true);
    };

    const [helperTextLocalizador, setHelperTextLocalizador] = useState('');
    const [helperTextCodigoBarras, setHelperTextCodigoBarras] = useState('');

    const [alertSnackbar, setAlertSnackbar] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
    const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

    const { formRef, save, saveAndReturn, isSaveAndReturn } = useVForm();

    const [isLoading, setIsLoading] = useState(false);

    const [cnpj, setCnpj] = useState<string>("");

    const [qtdeEtiquetas, setQtdeEtiquetas] = useState<number>(1);
    const [qtdeBaseEtiquetas, setQtdeBaseEtiquetas] = useState<number>(1);

    // const [tipo_de_caixa, setTipo_de_caixa] = useState<number>(0);

    const [ultimosLoc, setUltimosLoc] = useState<string[]>([]);

    const handleChangeLocalizador = (valorMascarado: string) => {
        setLocalizador(valorMascarado.toUpperCase());// colocar todas as letras digitas em maiúsculo
        setHelperTextLocalizador("");
    };
    const handleChangeCodigoBarras = (e: React.ChangeEvent<HTMLInputElement>) => {
        const regex = /^[0-9\b]+$/;// padrão para somente números
        if (e.target.value === "" || regex.test(e.target.value)) {// se encaixar no padão
            setCodigoBarras(e.target.value);
            setHelperTextCodigoBarras("");
        } else {
            setHelperTextCodigoBarras("Somente números");
        }
    };

    const limparCampos = () => {

        if (ultimosLoc.length > 0 || localizador !== '' || codigoBarras !== '') {
            setUltimosLoc((PrevLoc) => {
                if (localizador !== "" && localizador !== null && localizador !== undefined) {
                    const newLocs = ["Localizador: " + localizador, ...PrevLoc];
                    if (newLocs.length > 5) {
                        return newLocs.slice(0, 5);
                    }

                    return newLocs;
                } else {
                    const newLocs = ["Código de barras: " + codigoBarras, ...PrevLoc];
                    if (newLocs.length > 5) {
                        return newLocs.slice(0, 5);
                    }

                    return newLocs;
                }

            });
        }

        setLocalizador('');
        setTipoMascara("aa9-999-a-999");
        setCodigoBarras('');
        // LimparTransferLists();
        // setores.map(setor => setDisponivelSetor((prevSetores) => [...prevSetores, { idSetor: setor.idSetor, nomeSetor: setor.nomeSetor, disabled: false }]));// coloca todos os setores na lista de disponiveis
        // setSelectedIdsTipo([]);
        // setExpanded([]);
        // setIdsTipo([]);
        const idTipoCaixa = formRef.current?.getData().idTipoCaixa;
        formRef.current?.setData({
            observacao: '',
            identificador: '',
            idTipoCaixa: idTipoCaixa,
        });
        setIndices(indicesBase);
        setValores([]);
        limparHelperText();
        setQtdeEtiquetas(1);
        setQtdeBaseEtiquetas(1);
    }

    const limparHelperText = () => {
        setHelperTextCodigoBarras('');
        setHelperTextCodigoBarras('');
    }

    useEffect(() => {
        if (localStorage.getItem("cnpj") === null || localStorage.getItem("cnpj") === "" || localStorage.getItem("cnpj") === undefined) {
            // navigate(-1);
        } else {
            //@ts-expect-error
            setCnpj(localStorage.getItem("cnpj"));

        }
    }, [localStorage.getItem("cnpj")]);

    useEffect(() => {
        loadPage();
    }, [idCaixa]);


    const loadPage = () => {
        if (idCaixa !== "nova") {

            LimparTransferLists();
            setIsLoading(true);
            setIsLoadingLista(true);
            setTitulo("Carregando...");

            Detalhe_Caixa_Service.getByIdCaixa(Number(idCaixa)).then((result) => {
                setIsLoading(false);

                if (result instanceof Error) {// verificar se deu erro
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                } else {
                    setQtdeEtiquetas(result.qtdeEtiquetas ?? 1)
                    setQtdeBaseEtiquetas(result.qtdeEtiquetas ?? 1)
                    setLocalizador(result.localizador ?? "");
                    if (result.localizador !== undefined) {
                        if (result.localizador.length === 13) {

                            setTipoMascara("aa9-999-a-999");

                        } else {

                            setTipoMascara("aa9-999-aa-999");

                        }
                    }

                    setCodigoBarras(result.codigoBarras ?? '');
                    setTitulo(result.localizador !== "" && result.localizador !== undefined ? result.localizador : "Sem localizador");
                    formRef.current?.setData(result);

                    Detalhe_Caixa_Service.getIdUnidadeByIdCaixa(Number(idCaixa)).then((result) => {
                        if (result instanceof Error) {// verificar se deu erro
                            setIsLoadingLista(false);
                            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);
                        }
                        else {
                            setIdUnidade(result);
                        }
                    });

                    Detalhe_Caixa_Service.getSetoresByIdCaixa(Number(idCaixa)).then((result) => {
                        setIsLoadingLista(false);
                        if (result instanceof Error) {// verificar se deu erro
                            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);
                        }
                        else {
                            setSetores_caixa(result);
                            result.forEach(setor => {// para que os setores relacionados a essa caixa venha expandidos no treeview
                                setExpanded((prevExpanded) => [...prevExpanded, setor.nomeSetor]);
                            })
                        }
                    });

                    CaixaService.getTiposByIdCaixa(Number(idCaixa)).then((result) => {
                        if (result instanceof Error) {// verificar se deu erro
                            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);
                        }
                        else {
                            const resultTipo = result;

                            Detalhe_Caixa_Service.getIndicesByIdCaixa(Number(idCaixa)).then((result) => {

                                if (result instanceof Error) {// verificar se deu erro
                                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                                    setTimeout(() => {
                                        setAlertSnackbar(undefined);
                                    }, duracaoAlert);
                                } else {
                                    let valores: valoresIndices[] = [];
                                    let indices: ITipo_Indice_Documento[] = [];
                                    result.map(indice => {

                                        let idIndice = indice.idIndice;
                                        let valorInput = "";
                                        let valor = indice.valor;
                                        let dataInicial = indice.dataInicial;
                                        let dataFinal = indice.dataFinal;

                                        let indiceAux: ITipo_Indice_Documento = { idIndice: 0, nomeIndice: "", idComponente: 0, idTipo: 0, opcoes: "", indice_de_caixa: true };

                                        indiceAux.idIndice = indice.idIndice;
                                        indiceAux.nomeIndice = indice.indice.nomeIndice
                                        indiceAux.idComponente = indice.indice.idComponente;

                                        if (valor !== null) {
                                            valorInput = valor;
                                        } else if (dataFinal === null && dataInicial !== null) {
                                            valorInput = dataInicial;
                                        } else if (dataFinal !== null && dataInicial !== null) {
                                            dataInicial = dataInicial
                                            dataFinal = dataFinal


                                            valorInput = dataInicial + " | " + dataFinal;
                                        } else {
                                            valorInput = "";
                                        }
                                        indices.push(indiceAux);
                                        valores.push({ idIndice: idIndice, valor: valorInput, idIndice_caixa: indice.idIndice_caixa === undefined ? 0 : indice.idIndice_caixa });

                                    });
                                    setValores(valores);
                                    setIndices(indices);

                                }

                                resultTipo.map(setor => {
                                    setor.tipos.map(tipo => {
                                        let hierarquia: string[] = tipo.hierarquia.split('/');
                                        hierarquia.pop();
                                        setIdsTipo((prevIds) => [...prevIds, tipo.idTipo.toString()]);
                                        setSelectedIdsTipo((prevIds) => [...prevIds, tipo.idTipo.toString()]);
                                        tipo.hierarquia.split('/').forEach(hierarquia => {// expandir os tipos para ver melhor
                                            setExpanded((prevExpanded) => [...prevExpanded, hierarquia]);
                                        });
                                    })
                                });

                            });


                        }
                    });

                }
            });
        } else {// quando clicar no botão novo resetar os campos
            setLocalizador('');
            setTipoMascara("aa9-999-a-999");
            setCodigoBarras('');
            LimparTransferLists();
            setores.map(setor => setDisponivelSetor((prevSetores) => [...prevSetores, { idSetor: setor.idSetor, nomeSetor: setor.nomeSetor, disabled: false }]));// coloca todos os setores na lista de disponiveis
            setSelectedIdsTipo([]);
            setExpanded([]);
            setIdsTipo([]);
            limparCampos();
        }
    }

    //-------------------------------------------------------------------------------  Parte do transfer list -------------------------------------------------------------------------------
    function not(a: readonly SetoresLista[], b: readonly SetoresLista[]) {
        return a.filter((setor) => b.indexOf(setor) === -1);
    }

    function intersection(a: readonly SetoresLista[], b: readonly SetoresLista[]) {
        return a.filter((setor) => b.indexOf(setor) !== -1 &&
            !setor.disabled// não permitir que os setores que já estão relacionados a caixa sejam selecionados
        );
    }

    function union(a: readonly SetoresLista[], b: readonly SetoresLista[]) {
        return [...a, ...not(b, a)];
    }

    const [setores, setSetores] = useState<ISetor[]>([]);
    const [setores_caixa, setSetores_caixa] = useState<ISetor_Caixa[]>([]);
    const [isLoadingLista, setIsLoadingLista] = useState(false);

    useEffect(() => {// carregar os setores na lista

        if (idUnidade !== undefined && idUnidade !== null && idUnidade !== 0) {
            LimparListas();
            setSelectedIdsTipo([]);
            setExpanded([]);
            setIsLoadingLista(true);
            SetorService.list(idUnidade).then((result) => {
                setIsLoadingLista(false);
                if (result instanceof Error) {//verificar se deu erro
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                }
                else {
                    setSetores(result);
                }
            })
        } else {// limpar as listas ao deselecionar uma unidade 
            LimparListas();
            setSelectedIdsTipo([]);
            setExpanded([]);
        }

    }, [idUnidade]);

    function LimparListas() {
        setSetores([]);
        setDisponivelSetor([]);
        setSelecionadoSetor([]);
    }
    function LimparTransferLists() {
        setDisponivelSetor([]);
        setSelecionadoSetor([]);
    }

    const [checkedSetor, setCheckedSetor] = useState<readonly SetoresLista[]>([]);
    const [disponivelSetor, setDisponivelSetor] = useState<SetoresLista[]>([]);
    const [selecionadoSetor, setSelecionadoSetor] = useState<SetoresLista[]>([]);

    const disponivelSetorChecked = intersection(checkedSetor, disponivelSetor);
    const selecionadoCheckedSetor = intersection(checkedSetor, selecionadoSetor);

    const handleToggle = (setor: SetoresLista) => () => {
        const currentIndex = checkedSetor.indexOf(setor);
        const newChecked = [...checkedSetor];

        if (currentIndex === -1) {
            newChecked.push(setor);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setCheckedSetor(newChecked);
    };

    const setoresChecked = (items: readonly SetoresLista[]) =>
        intersection(checkedSetor, items).length;

    const handleToggleAll = (items: readonly SetoresLista[]) => () => {
        if (setoresChecked(items) === items.length) {
            setCheckedSetor(not(checkedSetor, items));
        } else {
            setCheckedSetor(union(checkedSetor, items));
        }
    };

    const handleCheckedRight = () => {
        setSelecionadoSetor(selecionadoSetor.concat(disponivelSetorChecked));
        setDisponivelSetor(not(disponivelSetor, disponivelSetorChecked));
        setCheckedSetor(not(checkedSetor, disponivelSetorChecked));
    };

    const handleCheckedLeft = () => {
        setDisponivelSetor(disponivelSetor.concat(selecionadoCheckedSetor));
        setSelecionadoSetor(not(selecionadoSetor, selecionadoCheckedSetor));
        setCheckedSetor(not(checkedSetor, selecionadoCheckedSetor));
    };

    useEffect(() => {// colocar os setores na lista de disponiveis        

        LimparTransferLists();// limpar as listas  ao selecionar uma unidade diferente
        setores.map(setor => setDisponivelSetor((prevSetores) => [...prevSetores, { idSetor: setor.idSetor, nomeSetor: setor.nomeSetor, disabled: false }]));// coloca todos os setores na lista de disponivelSetor

        if (idCaixa !== "nova") {
            setores.map(setor => {
                setores_caixa.map(setor_caixa => {
                    if (setor.idSetor === setor_caixa.idSetor) {// se a caixa tem esse setor
                        setSelecionadoSetor((prevSetores) => [...prevSetores, { idSetor: setor.idSetor, nomeSetor: setor.nomeSetor, disabled: true }]);// adiciona na lista de selecionados
                        setDisponivelSetor((current) => current.filter((disponivelSetor) => disponivelSetor.idSetor !== setor.idSetor));// remove da lista de disponiveis
                    }

                });
            });
        }
    }, [setores, setores_caixa]);

    const TITULO_LISTA_SELECIONADOS = 'Setores selecionados';// mostrar condicionalmente dependendo do titulo da lista(variavel criada para caso prescise mudar o titulo)

    const customList = (title: React.ReactNode, items: readonly SetoresLista[]) => {
        var length = items.length
        if (title === TITULO_LISTA_SELECIONADOS && !isLoadingLista && idCaixa !== "nova") {
            length = items.length - setores_caixa.length;
        }
        return (
            <Card sx={{ border: 1 }}>
                <CardHeader
                    sx={{ px: 2, py: 1 }}
                    avatar={
                        <Checkbox
                            onClick={handleToggleAll(items)}
                            checked={setoresChecked(items) === length && length !== 0}
                            indeterminate={
                                setoresChecked(items) !== length && setoresChecked(items) !== 0
                            }
                            disabled={length === 0}
                        />
                    }
                    title={title}
                    subheader={`${setoresChecked(items)}/${length} selecionados`}
                />
                {alertSnackbar !== undefined && (
                    <>
                        {alertSnackbar.tipoAlert === "sucesso" && (
                            <AlertSnackBar gravidade="success" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                        )}
                        {alertSnackbar.tipoAlert === "erro" && (
                            <AlertSnackBar gravidade="error" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                        )}
                        {alertSnackbar.tipoAlert === "aviso" && (
                            <AlertSnackBar gravidade="warning" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                        )}
                    </>
                )}
                <Divider />
                <List
                    sx={{
                        width: 230,
                        height: 230,
                        bgcolor: 'background.paper',
                        overflow: 'auto',
                    }}
                    dense
                    component="div"
                    role="list"
                >
                    {isLoadingLista && (<Box style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> <CircularProgress /> </Box>)}
                    {!isLoadingLista && items.map((setor: SetoresLista) => {
                        return (
                            <ListItem
                                key={setor.idSetor}
                                role="listitem"
                                button
                                onClick={handleToggle(setor)}
                                disabled={setor.disabled}
                            >
                                <ListItemIcon>
                                    <Checkbox
                                        checked={checkedSetor.indexOf(setor) !== -1 && !setor.disabled}
                                        tabIndex={-1}
                                        disableRipple
                                        disabled={setor.disabled}
                                    />
                                </ListItemIcon>
                                <ListItemText id={setor.idSetor.toString()} primary={setor.nomeSetor} />
                            </ListItem>
                        );
                    })}
                    <ListItem />
                </List>
            </Card>
        );
    }
    //-------------------------------------------------------------------------------  Fim da parte do transfer list -------------------------------------------------------------------------------

    const [isLoadingTipo, setIsLoadingTipo] = useState(false);
    const [rows, setRowsTipo] = useState<IListagemTipo[]>([]);
    var setorTipos: Array<{ nodeId: string, label: string, tipos: IListagemTipo[] }> = [];

    const [selectedIdsTipo, setSelectedIdsTipo] = useState<string[]>([]);
    const [idsTipo, setIdsTipo] = useState<string[]>([]);

    const handleClickOpen = () => {
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    const handleSelectTipo = (event: React.SyntheticEvent, nodeIds: string[]) => {
        const regex = /^[0-9\b]+$/;// para não entrar os setores que tambem estão na tree view
        nodeIds = nodeIds.filter(id => regex.test(id));

        setSelectedIdsTipo(nodeIds);
    };

    const handleToggleTipo = (event: React.SyntheticEvent, nodeIds: string[]) => {
        let expanded = nodeIds.filter((element, index) => {// remover duplicação
            return nodeIds.indexOf(element) === index;
        });
        setExpanded(expanded);
    };

    useEffect(() => {
        setRowsTipo([]);
        if (selecionadoSetor.length > 0) {
            setIsLoadingTipo(true);
            selecionadoSetor.forEach(setor => {
                TipoService.getByIdSetor(setor.idSetor, true).then((result) => {
                    setIsLoadingTipo(false);

                    if (result instanceof Error) {//verificar se deu erro
                        setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                        setTimeout(() => {
                            setAlertSnackbar(undefined);
                        }, duracaoAlert);

                        retirarDaLista(setor); // retirar da lista de selecionados caso de erro
                    }
                    else {
                        result.map(tipo => {
                            setRowsTipo((prevRows) => [...prevRows, tipo]);
                        })
                    }
                });
            });
        }
    }, [selecionadoSetor]);

    const retirarDaLista = (setor: SetoresLista) => {
        setSelecionadoSetor((prevSetores) => prevSetores.filter(setorAux => setorAux.idSetor !== setor.idSetor));
        setDisponivelSetor((prevSetores) => [...prevSetores, setor]);
    }

    selecionadoSetor.map(setor => {
        let aux: IListagemTipo[] = [];
        rows.map(tipo => {
            if (tipo.idSetor === setor.idSetor) {
                if (tipo.idSetor === setor.idSetor) {
                    aux = [...aux, tipo];
                } else {
                    return;
                }
            }
        });
        if (aux.length > 0) {
            setorTipos.push(
                {
                    'nodeId': setor.nomeSetor,
                    'label': setor.nomeSetor,
                    'tipos': aux,
                },
            );
        }
    });

    const renderTree = (nodes: RenderTree) => (
        <TreeItem key={nodes.idTipo} nodeId={(nodes.idTipo).toString()} label={nodes.nomeTipo}>
            {Array.isArray(nodes.tipos)
                ? nodes.tipos.map((node) => renderTree(node))
                : null}
        </TreeItem>
    );

    const [openDialog, setOpenDialog] = useState(false);
    //-------------------------------------------------------------------------------  Fim da parte dos tipos -------------------------------------------------------------------------------

    const handleSave = (dados: IFormData) => {

        if ((localizador === '' || localizador === null || localizador === undefined) && (codigoBarras === '' || codigoBarras === null || codigoBarras === undefined)) {
            setAlertSnackbar({ tipoAlert: "erro", mensagem: "Localizador e/ou Código de barras obrigatório" });
            setTimeout(() => {
                setAlertSnackbar(undefined);
            }, duracaoAlert);
            return;
        }

        dados.localizador = localizador.replaceAll("_", "");
        dados.codigoBarras = codigoBarras;
        var podeRetornar = true;
        var dadosSetor: IFormDataSetores[] = [];
        var dadosTipo: IFormDataTipos[] = [];
        dados.qtdeEtiquetas = qtdeEtiquetas;

        formValidationSchema.validate(dados, { abortEarly: false }).then(() => {
            // if (selecionadoSetor.length > 0 && selectedIdsTipo.length > 0) {/// se tiver algum setor e algum tipo selecionado
            setIsLoading(true);
            if (idCaixa === "nova") {

                Detalhe_Caixa_Service.create(dados).then((result) => {
                    if (result instanceof Error) {
                        podeRetornar = false;
                        setIsLoading(false);
                        setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                        setTimeout(() => {
                            setAlertSnackbar(undefined);
                        }, duracaoAlert);
                    } else {

                        if (selecionadoSetor.length > 0) {


                            const idCx = result;

                            selecionadoSetor.forEach(setor => {
                                dadosSetor.push({
                                    idSetor: setor.idSetor,
                                    idCaixa: idCx,
                                });
                            });
                            Detalhe_Caixa_Service.createSetores(dadosSetor).then((resultSetor) => {
                                if (resultSetor instanceof Error) {
                                    podeRetornar = false;
                                    setIsLoading(false);
                                    setAlertSnackbar({ tipoAlert: "erro", mensagem: resultSetor.message });
                                    setTimeout(() => {
                                        setAlertSnackbar(undefined);
                                    }, duracaoAlert);
                                } else {
                                    selectedIdsTipo.forEach(idTipo => {
                                        dadosTipo.push({
                                            idTipo: Number(idTipo),
                                            idCaixa: idCx,
                                        });
                                    });

                                    if (selectedIdsTipo.length > 0) {

                                        Detalhe_Caixa_Service.createTipos(dadosTipo).then((resultTipo) => {
                                            if (resultTipo instanceof Error) {
                                                podeRetornar = false;
                                                setIsLoading(false);
                                                setAlertSnackbar({ tipoAlert: "erro", mensagem: resultTipo.message });
                                                setTimeout(() => {
                                                    setAlertSnackbar(undefined);
                                                }, duracaoAlert);
                                            } else {

                                                /*=====================================================================================*/

                                                let dadosIndice: IIndice_caixa[] = ConversorDeValorIndice
                                                    .paraPayload(indices, valores.map((v) => v?.valor ?? ''))
                                                    .map((payload) => ({ ...payload, idCaixa: idCx }));

                                                if (dadosIndice.length !== 0) {

                                                    Detalhe_Caixa_Service.createIndice_caixa(dadosIndice).then((resultCaixa) => {
                                                        setIsLoading(false);
                                                        if (resultCaixa instanceof Error) {
                                                            setAlertSnackbar({ tipoAlert: "erro", mensagem: resultCaixa.message });
                                                            setTimeout(() => {
                                                                setAlertSnackbar(undefined);
                                                            }, duracaoAlert);
                                                        } else {

                                                            setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Caixa, tipos, setores e indices cadastrados com sucesso" });
                                                            setTimeout(() => {
                                                                setAlertSnackbar(undefined);
                                                            }, duracaoAlert);

                                                            if (isSaveAndReturn()) {
                                                                navigate(-1);
                                                            } else {
                                                                limparCampos();
                                                            }

                                                        }
                                                    });

                                                } else {

                                                    setIsLoading(false);
                                                    setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Caixa, setores e tipos cadastrados com sucesso" });
                                                    setTimeout(() => {
                                                        setAlertSnackbar(undefined);
                                                    }, duracaoAlert);

                                                    if (isSaveAndReturn()) {
                                                        navigate(-1);
                                                    } else {
                                                        limparCampos();
                                                    }

                                                }

                                            }
                                        });
                                    } else {

                                        setIsLoading(false);
                                        setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Caixa e setores cadastrados com sucesso" });
                                        setTimeout(() => {
                                            setAlertSnackbar(undefined);
                                        }, duracaoAlert);

                                        if (isSaveAndReturn()) {
                                            navigate(-1);
                                        } else {
                                            limparCampos();
                                        }

                                    }
                                }
                            });
                        } else {
                            setIsLoading(false);
                            setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Caixa cadastradas com sucesso" });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);

                            if (isSaveAndReturn()) {
                                navigate(-1);
                            } else {
                                limparCampos();
                            }

                        }
                    }
                });
                // formRef.current?.setData({
                //     localizador: '',
                //     codigoBarras: ''
                // });

            } else {
                //======================= INICIO DO UPDATE =========================//
                Detalhe_Caixa_Service.updateById({ idCaixa: Number(idCaixa), ...dados }).then((result) => {

                    setIsLoading(false);

                    if (result instanceof Error) {

                        setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                        setTimeout(() => {
                            setAlertSnackbar(undefined);
                        }, duracaoAlert);

                    } else {

                        setTitulo(dados.localizador !== "" && dados.localizador !== undefined ? dados.localizador : "Sem localizador");

                        selecionadoSetor.forEach(selecionado => {
                            if (!selecionado.disabled) {// se a relação com o setor ainda não existir adiciona no objeto
                                dadosSetor.push({
                                    idSetor: selecionado.idSetor,
                                    idCaixa: Number(idCaixa),
                                });
                            }
                        });
                        if (dadosSetor.length > 0) {// se houver um setor novo
                            setIsLoadingLista(true);
                            Detalhe_Caixa_Service.createSetores(dadosSetor).then((resultSetor) => {

                                setIsLoadingLista(false);

                                if (resultSetor instanceof Error) {

                                    setIsLoading(false);
                                    setAlertSnackbar({ tipoAlert: "erro", mensagem: resultSetor.message });
                                    setTimeout(() => {
                                        setAlertSnackbar(undefined);
                                    }, duracaoAlert);

                                } else {

                                    var aux = selecionadoSetor;// salva o valor
                                    setSelecionadoSetor([]);// limpa a lista
                                    aux.map(setor => {// criar uma nova lista que não pode ser alterada
                                        setSelecionadoSetor((prevSetores) => [...prevSetores, { idSetor: setor.idSetor, nomeSetor: setor.nomeSetor, disabled: true }]);
                                    });


                                    let diferencaTipo = selectedIdsTipo.filter(id => !idsTipo.includes(id));// pega a diferença entre o array de ids que ja estavam cadastrados com os selecionados
                                    diferencaTipo.forEach(idTipo => {
                                        dadosTipo.push({
                                            idTipo: Number(idTipo),
                                            idCaixa: Number(idCaixa),
                                        });
                                    });

                                    if (dadosTipo.length > 0) {// se tiver tipos novos
                                        Detalhe_Caixa_Service.createTipos(dadosTipo).then((resultTipo) => {
                                            setIsLoading(false);
                                            if (resultTipo instanceof Error) {
                                                setAlertSnackbar({ tipoAlert: "erro", mensagem: resultTipo.message });
                                                setTimeout(() => {
                                                    setAlertSnackbar(undefined);
                                                }, duracaoAlert);
                                            } else {
                                                setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Caixa, tipos e setores editados com sucesso" });
                                                setTimeout(() => {
                                                    setAlertSnackbar(undefined);
                                                }, duracaoAlert);

                                                if (isSaveAndReturn()) {
                                                    navigate(-1)
                                                }

                                            }
                                        });
                                    } else {
                                        setIdsTipo(selectedIdsTipo);// seta os novos tipos que não pode ser descelecionados
                                        setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Caixa e setores editados com sucesso" });
                                        setTimeout(() => {
                                            setAlertSnackbar(undefined);
                                        }, duracaoAlert);

                                        if (isSaveAndReturn()) {
                                            navigate(-1)
                                        }
                                    }
                                }
                            });
                        } else {// se não cadastra apenas os tipos

                            let diferencaTipo = selectedIdsTipo;

                            diferencaTipo.forEach(idTipo => {
                                dadosTipo.push({
                                    idTipo: Number(idTipo),
                                    idCaixa: Number(idCaixa),
                                });
                            });


                            Detalhe_Caixa_Service.createTipos(dadosTipo).then((resultTipo) => {

                                setIsLoading(false);
                                if (resultTipo instanceof Error) {

                                    setAlertSnackbar({ tipoAlert: "erro", mensagem: resultTipo.message });
                                    setTimeout(() => {
                                        setAlertSnackbar(undefined);
                                    }, duracaoAlert);

                                } else {

                                    setIdsTipo(selectedIdsTipo);// seta os novos tipos que não pode ser descelecionados
                                    setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Caixa, tipos e setores editados com sucesso" });
                                    setTimeout(() => {
                                        setAlertSnackbar(undefined);
                                    }, duracaoAlert);

                                }

                            });

                        }

                        let dadosIndice: IIndice_caixa[] = ConversorDeValorIndice
                            .paraPayload(indices, valores.map((v) => v?.valor ?? ''))
                            .map((payload, index) => ({
                                ...payload,
                                idCaixa: Number(idCaixa),
                                idIndice_caixa: valores[index]?.idIndice_caixa,
                            }));

                        if (dadosIndice.length !== 0) {

                            Detalhe_Caixa_Service.createIndice_caixa(dadosIndice).then((resultCaixa) => {
                                setIsLoading(false);
                                if (resultCaixa instanceof Error) {
                                    setAlertSnackbar({ tipoAlert: "erro", mensagem: resultCaixa.message });
                                    setTimeout(() => {
                                        setAlertSnackbar(undefined);
                                    }, duracaoAlert);
                                } else {

                                    setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Índices editados com sucesso" });
                                    setTimeout(() => {
                                        setAlertSnackbar(undefined);
                                    }, duracaoAlert);

                                    if (!isLoading) {
                                        loadPage();
                                    }

                                }
                            });

                        }
                        else {
                            if (!isLoading) {
                                loadPage();
                            }
                        }

                    }
                });

                // FIM DO UPDATE
                //============================================================================================//
            }
            // } else {

            //     setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Selecione ao menos um setor e um tipo" });
            //     setTimeout(() => {
            //         setAlertSnackbar(undefined);
            //     }, duracaoAlert);

            // }
        }).catch((errors: yup.ValidationError) => {
            const validationErrors: { [key: string]: string } = {};

            errors.inner.forEach(error => {
                if (!error.path) return;

                validationErrors[error.path] = error.message;
                // if (error.path === "localizador") setHelperTextLocalizador(error.message);
                if (error.path === "codigoBarras") setHelperTextCodigoBarras(error.message);
            });

            formRef.current?.setErrors(validationErrors);
        });
    }
    /*------------------------------------------------------------------------------------------------------------------------------------*/
    const handleDelete = (idCaixa: number) => {
        if (window.confirm('Realmente deseja desativar?')) {
            CaixaService.trocarEstado(idCaixa).then(result => {
                if (result instanceof Error) {//verificar se deu erro
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                } else {
                    setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Caixa desativada com sucesso" });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                    navigate(-1);
                }
            });
        }
    }

    interface valoresIndices {
        idIndice_caixa: number;
        idIndice: number;
        valor: string;
    }


    const [indicesBase, setIndicesBase] = useState<Omit<ITipo_Indice_Documento, 'idTipo'>[]>([]);
    const [indices, setIndices] = useState<Omit<ITipo_Indice_Documento, 'idTipo'>[]>([]);
    const [isLoadingIndices, setIsLoadingIndices] = useState(false);
    const [valores, setValores] = useState<valoresIndices[]>([]);

    useEffect(() => {
        if (selectedIdsTipo.length !== 0) {
            setIndices([]);
            setIsLoadingIndices(true);

            const auxIds = selectedIdsTipo.map(id => Number(id));

            Tipo_Indice_Service.getIndicesCaixaByIdTipo(auxIds, idCaixa).then(result => {
                setIsLoadingIndices(false);

                if (result instanceof Error) {
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                    return;
                }

                // Alinhar `valores` com os novos `indices`
                const valoresMap = new Map<number, valoresIndices[]>();

                // Agrupa todos os valores pelo idIndice
                valores.forEach(valor => {
                    if (!valoresMap.has(valor.idIndice)) {
                        valoresMap.set(valor.idIndice, []);
                    }
                    valoresMap.get(valor.idIndice)?.push(valor);
                });

                // Reordenar ou criar novos valores baseados em `indices`
                const valoresAtualizados = result.map(indice => {
                    const valoresDoIndice = valoresMap.get(indice.idIndice) || [];
                    if (valoresDoIndice.length > 0) {
                        // Remove e retorna o primeiro correspondente
                        return valoresDoIndice.shift()!;
                    } else {
                        // Cria um novo valor zerado
                        return {
                            idIndice_caixa: 0,
                            idIndice: indice.idIndice,
                            valor: ""
                        };
                    }
                });

                // Atualiza o estado
                setValores(valoresAtualizados);
                setIndices(result);

                if (idCaixa === "nova" || qtdeEtiquetas === 1) {
                    setIndicesBase(result);
                    setQtdeBaseEtiquetas(result.length);
                } else {
                    setIndicesBase(result.slice(0, result.length / qtdeEtiquetas));
                }
            });
        }
    }, [selectedIdsTipo]);


    function carregaIndices() {
        return (<>
            {indices.length > 0 && (<>
                <Typography sx={{ m: 2 }} variant="h4"> Índices </Typography>
                <Divider />
            </>
            )}

            {isLoadingIndices ? (
                <Grid container direction="row" justifyContent="center">
                    <Grid item xs={12}>
                        <LinearProgress variant='indeterminate' />
                    </Grid>
                </Grid>
            ) : (
                <IndicesCadastro
                    rowsAlterarValorIndice={indices}
                    initialValues={valores.map((v) => v?.valor ?? '')}
                    onValoresAlterarChange={(novosValores) => {
                        setValores(novosValores.map((valor, index) => ({
                            valor,
                            idIndice: indices[index]?.idIndice ?? 0,
                            idIndice_caixa: valores[index]?.idIndice_caixa ?? 0,
                        })));
                    }}
                    somenteLeitura={isLoading}
                    quebrarEmBlocosDeTamanho={indicesBase.length}
                />
            )}

            {indices.length > 0 && (
                <>
                    <br />
                    <Divider />
                </>
            )}
        </>)
    }

    const handleMoreIndices = () => {

        setIndices((PrevIndices) => {
            return [...PrevIndices, ...indicesBase]
        });

        setQtdeEtiquetas((PrevQtde) => {
            return PrevQtde + 1;
        });

        setValores((PrevValores) => {
            const newValue = [...PrevValores];

            indicesBase.map((indice) => {
                newValue.push({ idIndice: indice.idIndice, valor: "", idIndice_caixa: 0 })
            });

            return newValue;
        });

    }

    const handlelessIndices = () => {

        setIndices((PrevIndices) => {
            var newValue = [...PrevIndices];
            newValue = newValue.slice(0, newValue.length - indicesBase.length);
            return newValue;
        });

        setQtdeEtiquetas((PrevQtde) => {
            return PrevQtde - 1;
        });

        setValores((PrevValores) => {
            var newValue = [...PrevValores];
            newValue = newValue.slice(0, newValue.length - indicesBase.length);
            return newValue
        });
    }

    const [openDialogImport, setOpenDialogImport] = useState(false);

    const handleCloseDialogImport = () => {
        setOpenDialogImport(false);
    }

    const handleOpenDialogImport = () => {
        setOpenDialogImport(true);
    }

    const [selectedFile, setSelectedFile] = useState();
    const [isFilePicked, setIsFilePicked] = useState(false);
    const [isLoadingImport, setIsLoadingImport] = useState(false);

    //@ts-expect-error
    const handleArquivo = (event) => {
        if (!!event.target.files[0]) {
            setSelectedFile(event.target.files[0]);
            setIsFilePicked(true);
        }
    }

    const handleImport = () => {
        if (selectedFile) {
            setIsLoadingImport(true);
            const formData = new FormData();
            formData.append('file', selectedFile);

            Detalhe_Caixa_Service.importarLocalizadores(formData).then(result => {
                setIsLoadingImport(false);
                setOpenDialogImport(false);
                setIsFilePicked(false);
                setSelectedFile(undefined);

                if (result instanceof Error) {
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                }
                else {
                    setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Localizadores importados com sucesso" });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                }
            });

        }
        else {
            setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Selecione um arquivo" });
            setTimeout(() => {
                setAlertSnackbar(undefined);
            }, duracaoAlert);
        }
    }

    return (

        <LayoutBaseDePagina titulo={idCaixa === 'nova' ? 'Nova caixa' : titulo} barraDeFerramentas={
            <>
                <Box
                    component={Paper}
                    height={theme.spacing(5)}
                    marginX={1}
                    padding={1}
                    paddingX={2}
                    display="flex"
                    gap={1}
                    alignItems="center"
                >

                    {idCaixa !== 'nova' ? (
                        <Button
                            color={themeName == 'light' ? 'secondary' : 'primary'}
                            disableElevation
                            variant="outlined"
                            startIcon={<Icon color={themeName == 'light' ? 'secondary' : 'primary'}>arrow_back</Icon>}
                            onClick={() => navigate(-1)}
                        >
                            <Typography
                                variant='button'
                                noWrap
                                color={themeName == 'light' ? 'secondary' : 'primary'}
                            >
                                Voltar
                            </Typography>
                        </Button>
                    ) : (
                        <AutoCompleteDeUnidade selectedIdUnidade={selectedIdUnidade => setIdUnidade(selectedIdUnidade)} />
                    )}

                    <Box flex="1" display="flex" justifyContent="end" gap={1}>

                        <Button variant="contained" startIcon={<Icon>publish</Icon>} disabled={isLoading} onClick={handleOpenDialogImport} color="primary" disableElevation>
                            <Typography variant='button' noWrap>
                                Importar localizadores
                            </Typography>
                        </Button>

                        <Button variant="contained" startIcon={<Icon>save</Icon>} disabled={isLoading} onClick={save} color="primary" disableElevation>
                            <Typography variant='button' noWrap>
                                Salvar
                            </Typography>
                        </Button>

                    </Box>

                </Box>
            </>
        }
        >
            <Dialog
                open={openDialogImport}
                onClose={handleCloseDialogImport}
            >
                <DialogTitle id="scroll-dialog-title"> Importar Localizadores </DialogTitle>
                <DialogContent dividers>
                    <Grid container item direction="column" spacing={2} sx={{ mt: 3, mb: 3 }} textAlign={"center"}>

                        {/* <Typography>Mesclar novo anexo no: </Typography> */}

                        <Grid container item direction="row" spacing={2}>

                            <Grid item>
                                <Box display="flex" gap={1} alignItems="center">
                                    <Button
                                        variant="contained"
                                        component="label"
                                        disabled={isLoading || isLoadingImport}
                                    >
                                        <Typography variant='button' noWrap> Selecionar arquivo </Typography>
                                        <input
                                            type="file"
                                            accept='.xlsx'
                                            hidden
                                            onChange={handleArquivo}
                                        />
                                    </Button>
                                    {isFilePicked ? (
                                        //@ts-expect-error
                                        <Typography> {selectedFile.name} </Typography>
                                    ) : (
                                        <Typography> Nenhum arquivo selecionado </Typography>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Box
                        width="100%"
                        marginX={1}
                        padding={1}
                        paddingX={2}
                        gap={1}
                        display="flex"
                        justifyContent="center"
                    >
                        <Button variant="contained" color="error" startIcon={<Icon>close</Icon>} onClick={handleCloseDialogImport} disabled={isLoadingImport}>
                            <Typography variant='button' noWrap> Fechar </Typography>
                        </Button>
                        <Button variant="contained" startIcon={<Icon>check</Icon>} onClick={handleImport} disabled={isLoadingImport}>
                            <Typography variant='button' noWrap> Confirmar </Typography>
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>


            {isLoading && (
                <LinearProgress variant="indeterminate" />
            )}

            {alertSnackbar !== undefined && (
                <>
                    {alertSnackbar.tipoAlert === "sucesso" && (
                        <AlertSnackBar gravidade="success" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alertSnackbar.tipoAlert === "erro" && (
                        <AlertSnackBar gravidade="error" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alertSnackbar.tipoAlert === "aviso" && (
                        <AlertSnackBar gravidade="warning" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                </>
            )}

            <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">

                <VForm ref={formRef} onSubmit={handleSave}>

                    {/* {idCaixa === "nova" && (
                        <>
                            <Box marginX={3} padding={2} paddingX={2} marginTop={1}></Box>

                            <Grid container item direction="row" spacing={2} justifyContent="center" alignItems="center">
                                <Box display="flex" gap={3} alignItems="center">
                                    <AutoCompleteDeUnidade paraCadastro selectedIdUnidade={selectedIdUnidade => setIdUnidade(selectedIdUnidade)} />
                                </Box>
                            </Grid>
                        </>
                    )} */}

                    <Box width="100%" height="100%" sx={{ display: { lg: 'block', xl: 'flex' } }} >
                        <Grid container direction="column" padding={2} spacing={2}>

                            <Box marginX={1} padding={1} paddingX={2}></Box>

                            <Grid container spacing={2} justifyContent="center" alignItems="center">
                                <Grid item>{customList('Setores disponíveis', disponivelSetor)}</Grid>
                                <Grid item>
                                    <Grid container direction="column" alignItems="center">
                                        <Button
                                            sx={{
                                                my: 0.5,
                                                color: themeName === 'light' ? 'secondary.main' : 'primary.main',
                                                '&.Mui-disabled': {
                                                    color: 'theme.palette.action.disabled',
                                                },
                                                borderColor: themeName === 'dark' ? 'primary.main' : 'secondary.main',
                                            }}
                                            variant="outlined"
                                            size="small"
                                            onClick={handleCheckedRight}
                                            disabled={disponivelSetorChecked.length === 0}
                                        >
                                            &gt;
                                        </Button>
                                        <Button
                                            sx={{
                                                my: 0.5,
                                                color: themeName === 'light' ? 'secondary.main' : 'primary.main',
                                                '&.Mui-disabled': {
                                                    color: 'theme.palette.action.disabled',
                                                },
                                                borderColor: themeName === 'dark' ? 'primary.main' : 'secondary.main',
                                            }}
                                            variant="outlined"
                                            size="small"
                                            onClick={handleCheckedLeft}
                                            disabled={selecionadoCheckedSetor.length === 0}
                                        >
                                            &lt;
                                        </Button>
                                    </Grid>
                                </Grid>
                                <Grid item>{customList(TITULO_LISTA_SELECIONADOS, selecionadoSetor)}</Grid>
                            </Grid>

                        </Grid>


                        <Box marginX={1} padding={1} paddingX={2}></Box>



                        <Grid container direction="column" padding={2} spacing={2}>

                            <Grid container justifyContent="center" item direction="column" spacing={2}>

                                <Grid container item direction="row" spacing={2} >

                                    <Grid item xs={12} sm={12} md={10} lg={8}>
                                        <AutoCompleteDeTipoDeCaixa paraCadastro isExternalLoading={isLoading} width={538} disabled={idUnidade === undefined ? true : false} />
                                    </Grid>

                                </Grid>

                                <Grid container item direction="row" spacing={2} >

                                    <Grid item xs={12} sm={12} md={10} lg={8}>
                                        <VTextField fullWidth multiline minRows={2} name="observacao" label="Observações" placeholder="Digite o algo..." disabled={isLoading} />
                                    </Grid>

                                </Grid>

                                <Grid container item direction="row" spacing={2} >

                                    <Grid item xs={12} sm={12} md={10} lg={8}>
                                        <TextField fullWidth label="Código de barras" placeholder="Digite o código..." disabled={isLoading} value={codigoBarras} onChange={handleChangeCodigoBarras} helperText={helperTextCodigoBarras} error={!!helperTextCodigoBarras} />
                                    </Grid>

                                </Grid>


                                <Grid container item direction="row" spacing={2} >

                                    <Grid item xs={12} sm={12} md={5} lg={4}>
                                        <CampoTextoMascarado
                                            fullWidth
                                            mask={tipoMascara}
                                            label="Localizador"
                                            placeholder="Digite o localizador..."
                                            disabled={isLoading}
                                            helperText={helperTextLocalizador}
                                            error={!!helperTextLocalizador}
                                            value={localizador}
                                            onChange={(valorMascarado) => handleChangeLocalizador(valorMascarado)}
                                            InputProps={{
                                                endAdornment:

                                                    <ClickAwayListener onClickAway={handleTooltipMascaraClose}>
                                                        <div>

                                                            <HtmlTooltip PopperProps={{ disablePortal: true, }} onClose={handleTooltipMascaraClose} open={showTooltipMascara} disableFocusListener disableHoverListener disableTouchListener arrow title={
                                                                <React.Fragment>

                                                                    <FormControl>

                                                                        <FormLabel> Tipo de Localizador </FormLabel>

                                                                        <RadioGroup
                                                                            row
                                                                            value={tipoMascara}
                                                                            onChange={(event) => {

                                                                                setTipoMascara(event.target.value);
                                                                                setLocalizador('');
                                                                                setTimeout(() => {

                                                                                    handleTooltipMascaraClose();

                                                                                }, 500);

                                                                            }}
                                                                        >

                                                                            <FormControlLabel value="aa9-999-a-999" control={<Radio color={themeName == "dark" ? 'primary' : "secondary"} />} label="aa9-999-a-999" />
                                                                            <FormControlLabel value="aa9-999-aa-999" control={<Radio color={themeName == "dark" ? 'primary' : "secondary"} />} label="aa9-999-aa-999" />

                                                                        </RadioGroup>

                                                                    </FormControl>

                                                                </React.Fragment>
                                                            }>

                                                                <IconButton
                                                                    edge="end"
                                                                    onClick={handleTooltipMascaraOpen}
                                                                >
                                                                    <Icon color={themeName == 'dark' ? 'primary' : 'secondary'}>settings</Icon>
                                                                </IconButton>

                                                            </HtmlTooltip>

                                                        </div>
                                                    </ClickAwayListener>

                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={5} lg={4}>
                                        <VTextField fullWidth name="identificador" label="Identificador" placeholder="Digite o Identificador..." disabled={isLoading} />
                                    </Grid>

                                </Grid>


                            </Grid>

                        </Grid>

                    </Box>

                    {/* <Box marginX={1} padding={1} paddingX={2}></Box>

                    <Box
                        display="flex"
                        justifyContent="center"
                    >
                        <Button
                            variant="contained"
                            disabled={isLoadingTipo || setorTipos.length === 0}
                            onClick={handleClickOpen}
                            endIcon={isLoadingTipo ? <CircularProgress variant='indeterminate' color='inherit' size={20} /> : undefined}
                        >
                            Mostrar tipos
                        </Button>
                    </Box> */}

                    <Box marginX={1} padding={1} paddingX={2}></Box>

                    <Box
                        display="flex"
                        justifyContent="center"
                    >
                        <Button
                            variant="contained"
                            disabled={isLoadingTipo || setorTipos.length === 0}
                            onClick={handleClickOpen}
                            endIcon={isLoadingTipo ? <CircularProgress variant='indeterminate' color='inherit' size={20} /> : undefined}
                        >
                            Mostrar tipos
                        </Button>
                    </Box>

                    <Box paddingY={2} ></Box>

                    {carregaIndices()}

                    <Box
                        display="flex"
                        justifyContent="center"
                        mb={2}
                    >
                        {indices.length > 0 &&
                            <Grid textAlign={"center"} width="100vh" mt={5}>
                                <Button variant="contained" onClick={handlelessIndices} disabled={qtdeEtiquetas === 1}>
                                    <Icon> remove </Icon>
                                </Button>
                            </Grid>
                        }
                        {indices.length > 0 &&
                            <Grid textAlign={"center"} width="100vh" mt={5}>
                                <Button variant="contained" onClick={handleMoreIndices}>
                                    <Icon> add </Icon>
                                </Button>
                            </Grid>
                        }
                    </Box>

                    <Dialog
                        open={openDialog}
                        onClose={handleClose}
                    >
                        <DialogTitle id="scroll-dialog-title"> Tipos </DialogTitle>
                        <DialogContent dividers>
                            {isLoadingTipo ? (
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <CircularProgress />
                                </Box>
                            ) : (
                                <TreeView
                                    defaultCollapseIcon={<ExpandMoreIcon />}
                                    defaultExpandIcon={<ChevronRightIcon />}
                                    multiSelect
                                    selected={selectedIdsTipo}
                                    expanded={expanded}
                                    onNodeSelect={handleSelectTipo}
                                    onNodeToggle={handleToggleTipo}
                                    sx={{ width: 500, minHeight: 200, flexGrow: 1 }}
                                >
                                    {setorTipos.map(setor => (
                                        <TreeItem key={setor.nodeId} nodeId={setor.nodeId} label={setor.label}>
                                            {setor.tipos.map(tipo => renderTree(tipo))}
                                        </TreeItem>
                                    ))}
                                </TreeView>
                            )}

                            <HtmlTooltip arrow title={
                                <React.Fragment>
                                    Para que um tipo seja listado aqui, é necessário que tenha no mínimo 1 (um) índice de CAIXA
                                </React.Fragment>
                            }>

                                <Typography variant='caption' > <u> Não encontrou algum tipo? </u> </Typography>

                            </HtmlTooltip>

                        </DialogContent>
                        <DialogActions>
                            <Box
                                width="100%"
                                marginX={1}
                                padding={1}
                                paddingX={2}
                                gap={1}
                                display="flex"
                                justifyContent="center"
                            >
                                <Button variant="contained" color="error" startIcon={<Icon>close</Icon>} onClick={handleClose}>
                                    <Typography variant='button' noWrap> Fechar </Typography>
                                </Button>
                                <Button variant="contained" startIcon={<Icon>check</Icon>} onClick={handleClose}>
                                    <Typography variant='button' noWrap> Confirmar </Typography>
                                </Button>
                            </Box>
                        </DialogActions>
                    </Dialog>

                </VForm>


                {ultimosLoc.length !== 0 &&
                    <Grid width={"100%"} textAlign={"center"} mt={5}>
                        <Typography typography={"h4"} m={2}> Últimos cadastros </Typography>
                        <Divider />
                        {ultimosLoc.map((loc, index) => (
                            <Typography key={`${loc}-${index}`} typography={"h5"} mt={2}>
                                {loc}
                            </Typography>
                        ))}
                    </Grid>
                }

            </Box>

        </LayoutBaseDePagina>
    )
}
